import React, { useState, useRef, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { 
    Flex, Box, Heading, Input, Button, ButtonGroup, Text, CircularProgress, CircularProgressLabel,
    InputGroup, InputLeftElement, InputRightElement, Icon, IconButton, Select,
    Stack, HStack, Image, Wrap, WrapItem, Center, InputRightAddon,
    Tabs, Tab, TabList, TabPanels, TabPanel,
    Table, Thead, Tbody, Tfoot, Tr, Th, Td, TableCaption, TableContainer, useDisclosure, useToast,
    VStack
} from '@chakra-ui/react';
import ReactPaginate from 'react-paginate';
import { MdSettings, MdAdd, MdAddCircleOutline, MdCalendarToday, MdSearch, MdEdit, MdDeleteForever, MdSave } from 'react-icons/md';
import { BsArrowLeftCircle, BsArrowRightCircle } from 'react-icons/bs';
import { useNavigate, useLocation } from 'react-router-dom';
import { FormattedDate, FormattedTime } from 'react-intl';
import { MultiSelect } from "react-multi-select-component";
import { sleep, confirmChoice } from "../../utils/helpers"
import Users from '../Users';
import httpClient from '../../services/http-client';

const SORT_BY_LIST = [
    { title: "Theo thời gian", value: "id" },
    { title: "Theo họ tên", value: "full_name" },
];

const SORT_DIR_LIST = [
    { title: "Giảm dần", value: "desc" },
    { title: "Tăng dần", value: "asc" }, 
];

function Admin() {
    const [ cookies, setCookie, removeCookie ] = useCookies(["loginCookie"]);
    const [isAllowAccessThisPage, setIsAllowAccessThisPage] = useState(true);
    const initialRef = useRef(null);
    const toast = useToast();
    const navigate = useNavigate();
    const { search } = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [initDatas, setInitDatas] = useState({});
    const [settingDatas, setSettingDatas] = useState({});
    const [selectedParentStoreName, setSelectedParentStoreName] = useState(null);
    const [selectedChildStoreNames, setSelectedChildStoreNames] = useState([]);
    const [newStoreName, setNewStoreName] = useState(null);
    const [newWarehouseName, setNewWarehouseName] = useState(null);
    const mouted = useRef();

    const query = new URLSearchParams(search);
   
    useEffect(() => {
        if(!mouted.current) {
            if(cookies.loginCookie?.data?.scope !== "admin") {
                setIsAllowAccessThisPage(false);
            }
            loadInitDatas();
            loadSetting();
            mouted.current = true;
        }
    }, []);
    //console.log("--- settingDatas:", settingDatas);
    const loadInitDatas = async() => {
        setIsLoading(true);
        const res = await httpClient.get(`/larksuite/init-datas`);
        if(!res.data.error) {
            setInitDatas(res.data.data);
            setIsLoading(false);
        } else {
            toast({
                title: "Lỗi load dữ liệu!",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
            setIsLoading(false);
        }
    }

    const loadSetting = async() => {
        setIsLoading(true);
        const res = await httpClient.get(`/setting`);
        // console.log("--- loadSetting res:", res);
        if(!res.data.error) {
            setSettingDatas(res.data.data);
            setIsLoading(false);
        } else {
            toast({
                title: "Lỗi load cài đặt!",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
            setIsLoading(false);
        }
    }

    const handleMergeStores = async() => {
        // console.log("--- selectedParentStoreName:", selectedParentStoreName);
        // console.log("--- selectedChildStoreNames:", selectedChildStoreNames);
        const childStoreNames = selectedChildStoreNames.map(item => item.value);
        // console.log("--- childStoreNames:", childStoreNames);
        // Implement the logic to merge stores here
        if(!selectedChildStoreNames || selectedChildStoreNames.length === 0) {
            alert("Vui lòng chọn chi nhánh cần gom!");
            return;
        } else if(!selectedParentStoreName) {
            alert("Vui lòng chọn chi nhánh gốc!");
            return;
        } else if(childStoreNames.includes(selectedParentStoreName)) {
            alert("Chi nhánh gốc không thể nằm trong danh sách chi nhánh cần gom!");
            return;
        }

        confirmChoice("Bạn có đồng ý cập nhật dữ liệu?", async() => {
            setIsLoading(true);
            if(settingDatas?._id) {
                const settingUpdateRes = await httpClient.post(`/setting/update`, {
                    "_id": settingDatas._id,
                    "merge_store_revenue": [
                         ...settingDatas.merge_store_revenue,
                        {
                            "parentStoreName": selectedParentStoreName,
                            "childStoreNames": childStoreNames
                        }
                    ]
                });
                //console.log("--- handleMergeStores res:", settingUpdateRes);
                if(!settingUpdateRes.data.error) {
                    setSettingDatas(settingUpdateRes.data?.data);
                    setIsLoading(false);
                    toast({
                        title: "Lưu dữ liệu thành công!",
                        status: "success",
                        duration: 3000,
                        isClosable: true,
                    });
                } else {
                    toast({
                        title: "Lỗi cập nhật dữ liệu!",
                        status: "error",
                        duration: 3000,
                        isClosable: true,
                    });
                    setIsLoading(false);
                }
            } else {
                const settingAddRes = await httpClient.post(`/setting/add`, {
                    "merge_store_revenue": [
                        {
                            "parentStoreName": selectedParentStoreName,
                            "childStoreNames": childStoreNames
                        }
                    ]
                });
                //console.log("--- handleMergeStores res:", settingAddRes);
                if(!settingAddRes.data.error) {
                    setSettingDatas(settingAddRes.data?.data);
                    setIsLoading(false);
                    toast({
                        title: "Lưu dữ liệu thành công!",
                        status: "success",
                        duration: 3000,
                        isClosable: true,
                    });
                } else {
                    toast({
                        title: "Lỗi thêm dữ liệu!",
                        status: "error",
                        duration: 3000,
                        isClosable: true,
                    });
                    setIsLoading(false);
                }
            }
        })
    }

    const handleRemoveMergeStore = async (parentStoreName) => {
        confirmChoice("Bạn có muốn xoá không?", async() => {   
            const updatedMergeStoreRevenue = settingDatas?.["merge_store_revenue"]?.filter(item => item.parentStoreName !== parentStoreName);

            const settingUpdateRes = await httpClient.post(`/setting/update`, {
                "_id": settingDatas?._id,
                "merge_store_revenue": updatedMergeStoreRevenue
            });
            if(!settingUpdateRes.data.error) {
                setSettingDatas(settingUpdateRes.data?.data);
                toast({
                    title: "Xoá dữ liệu thành công!",
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                });
            } else {
                toast({
                    title: "Lỗi xoá dữ liệu!",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                });
            }
        });  
    }

    const handleAddStore = async () => {    
        if(!newStoreName) {
            alert("Vui lòng nhập thông tin chi nhánh!");
            return;
        } 
        if(!newWarehouseName) {
            alert("Vui lòng nhập thông tin kho!");
            return;
        } 

        confirmChoice("Bạn có muốn thêm chi nhánh không?", async() => {
            const settingUpdateRes = await httpClient.post(`/setting/update`, {
                "_id": settingDatas?._id,
                "stores": [...(settingDatas?.["stores"] || []), {store_name: newStoreName, warehouse_name: newWarehouseName} ]
            });
            if(!settingUpdateRes.data.error) {
                setSettingDatas(settingUpdateRes.data?.data);
                toast({
                    title: "Thêm chi nhánh thành công!",
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                });
            } else {
                toast({
                    title: "Thêm chi nhánh thất bại!",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                });
            }
        });
    }
    
    if(!isAllowAccessThisPage) {
        return (
            <Flex w="100%" p={4} flexDirection="column" alignItems="flex-start" justify="flex-start" h="100vh">
                <Text color="red.500"  fontSize="2xl" fontWeight="bold">**** Bạn không có quyền truy cập trang này (vui lòng liên hệ admin) ****</Text>
            </Flex>
        );
    }

    const SettingComponent = () => {
        return (
            <Flex flexDirection="column" gap={8}>
                <Box>
                    <Heading size="md">Danh sách chi nhánh</Heading>
                    <Flex flexDirection="column" gap={2}>
                        {
                            settingDatas?.stores?.length > 0 ?
                            settingDatas?.stores.map((item, idx) => (
                                <HStack key={`store-${idx}`} align="start">
                                    <Text>Tên chi nhánh:</Text>
                                    <Text fontWeight="bold" color="blue.500">{item?.store_name}</Text>
                                    <Text>Tên kho:</Text>
                                    <Text fontWeight="bold" color="blue.500">{item?.warehouse_name}</Text>
                                </HStack>
                            ))
                            :
                            (<Text>Chưa có dữ liệu chi nhánh</Text>)
                        }
                    </Flex>
                    <Flex flexDirection="column" gap={2} boxShadow="md" p={4} borderRadius="md">
                        <Text fontSize={16}>Tên chi nhánh mới:</Text>
                        <Input type="text" value={newStoreName} onChange={(e) => setNewStoreName(e.target.value)} />
                        <Text fontSize={16}>Tên kho mới:</Text>
                        <Input type="text" value={newWarehouseName} onChange={(e) => setNewWarehouseName(e.target.value)} />
                        <Button isDisabled={!newStoreName || !newWarehouseName} maxW="200px" colorScheme="blue" onClick={handleAddStore}>Thêm chi nhánh</Button>
                    </Flex>

                </Box>
                <Box>
                    <Heading size="md">Gom doanh thu về chi nhánh</Heading>
                    <HStack spacing={4} align="stretch" gap={8}>
                        <HStack>
                            <Text>Chọn chi nhánh gốc:</Text>
                            <div>
                                <Select size="sm" value={selectedParentStoreName} placeholder="Chọn chi nhánh gốc"
                                    onChange={
                                        (evt) => { setSelectedParentStoreName(evt.target.value) }
                                    }
                                >
                                    {
                                        initDatas?.["Fabi05"] &&
                                        ([...Object.keys(initDatas?.["Fabi05"]).sort((a, b) => a.localeCompare(b))] || []).map((key, idx) => (
                                            <option key={`original-store-name-${idx}`} value={key}>{key}</option>
                                        ))
                                    }
                                </Select>
                            </div>                     
                        </HStack>
                        <HStack>
                            <Text>Chi nhánh cần gom:</Text>
                            <div style={{ minWidth: "200px" }}>
                                <MultiSelect 
                                    options={
                                        initDatas?.["Fabi05"] &&
                                            ([...Object.keys(initDatas?.["Fabi05"]).sort((a, b) => a.localeCompare(b))] || []).map((key, idx) => (
                                                { label: key, value: key }
                                            )) || []
                                    }   
                                    value={selectedChildStoreNames}
                                    onChange={setSelectedChildStoreNames}
                                    labelledBy='Select'
                                />
                            </div>
                        </HStack>

                    </HStack>
                    <VStack align="flex-start" justify="flex-start">
                        <Text fontWeight="bold">Danh sách chi nhánh đã gom:</Text>
                        {
                            settingDatas?.merge_store_revenue?.length > 0 ?
                                settingDatas?.merge_store_revenue.map((item, idx) => (
                                    <HStack key={`merge-store-revenue-${idx}`} align="start">
                                        <Text>{`${item?.parentStoreName}`}{` <---- ${item?.childStoreNames?.join(", ")}`}</Text>
                                        <Button size="sm" colorScheme="red"
                                            onClick={() => handleRemoveMergeStore(item?.parentStoreName)}
                                        >
                                            <Icon boxSize={6} as={MdDeleteForever} marginRight="8px"/> 
                                            Xóa
                                        </Button>
                                    </HStack>
                                ))
                                :
                                (<Text>Chưa có dữ liệu</Text>)
                        }
                    </VStack>
                    <HStack spacing={4} align="stretch" gap={8} justify="flex-end">
                        <Button colorScheme="blue" onClick={() => handleMergeStores()}>Gom chi nhánh</Button>
                    </HStack>
                </Box>
            </Flex>
        );
    }

    return (
        <Flex flexDirection="column" p={4} minHeight="100vh">
            <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} justify="flex-start">
                <Flex flexDirection="column">
                    <Heading size="lg">Quản trị Admin</Heading>
                    <Tabs p={2}>
                        <TabList>
                            <Tab textTransform="uppercase">Tài khoản</Tab>
                            <Tab textTransform="uppercase">Cài đặt</Tab>
                        </TabList>
                        <TabPanels>
                            <TabPanel>
                                <Users />
                            </TabPanel>
                            <TabPanel>
                                <SettingComponent />
                            </TabPanel>
                        </TabPanels>
                    </Tabs>
                </Flex>
            </Flex>
        </Flex>
    )
}

export default Admin;